import { render } from "./indexeightchoose.vue?vue&type=template&id=af5fd2f8"
import script from "./indexeightchoose.vue?vue&type=script&lang=js"
export * from "./indexeightchoose.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__